import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AuthUser} from '../../services/authApi';

interface UserState {
  currentUser: AuthUser | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  currentUser: null,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AuthUser>) => {
      state.currentUser = action.payload;
    },
    clearUser: (state) => {
      state.currentUser = null;
    },
    updateUser: (state, action: PayloadAction<Partial<AuthUser>>) => {
      if (state.currentUser) {
        state.currentUser = {...state.currentUser, ...action.payload};
      }
    },
  },
});

export const {setUser, clearUser, updateUser} = userSlice.actions;
export default userSlice.reducer;
